export const FETCH_EXTERNAL_ITEMS_START = 'UMS_FETCH_EXTERNAL_ITEMS_START';
export const FETCH_EXTERNAL_ITEMS_SUCCESS = 'UMS_FETCH_EXTERNAL_ITEMS_SUCCESS';
export const FETCH_EXTERNAL_ITEMS_ERROR = 'UMS_FETCH_EXTERNAL_ITEMS_ERROR';
export const FETCH_EXTERNAL_DXSCHEMA_START = 'UMS_FETCH_EXTERNAL_DXSCHEMA_START';
export const FETCH_EXTERNAL_DXSCHEMA_SUCCESS = 'UMS_FETCH_EXTERNAL_DXSCHEMA_SUCCESS';
export const FETCH_EXTERNAL_DXSCHEMA_ERROR = 'UMS_FETCH_EXTERNAL_DXSCHEMA_ERROR';
